import React, {useState} from "react";
import {useQuery} from "react-tools";
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal} from "react-bootstrap";
import {registerOrganizationUser} from "api";
import {Redirect} from "react-router-dom";

function Registration ({onSuccess}) {
    const [surname, setSurname] = useState('');
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    let query = useQuery();

    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            surname,
            name,
            lastname,
        };

        const user = await registerOrganizationUser(query.get('token'), data);
        onSuccess(user);
    }

    if (!query.get('token')) {
        return (
            <Redirect to="/" />
        );
    }

    return (
        <Form horizontal onSubmit={handleSubmit}>
            <Modal.Dialog>
                <Modal.Body>
                    <p>Для завершения регистрации заполните необходимые данные</p>
                    <FormGroup>
                        <Col componentClass={ControlLabel} sm={3}>Фамилия</Col>
                        <Col sm={9}>
                            <FormControl
                                name="surname"
                                type="text"
                                required
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col componentClass={ControlLabel} sm={3}>Имя</Col>
                        <Col sm={9}>
                            <FormControl
                                name="name"
                                type="text"
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col componentClass={ControlLabel} sm={3}>Отчество</Col>
                        <Col sm={9}>
                            <FormControl
                                name="lastname"
                                type="text"
                                value={lastname}
                                onChange={(e) => setLastname(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" bsStyle="primary">Зарегистрироваться</Button>
                </Modal.Footer>
            </Modal.Dialog>
        </Form>
    );
}

export default Registration;
